import React from "react";

const VIEWS = [
  { id: "terms", label: "Terms" },
  { id: "month", label: "Month" },
  { id: "list", label: "Upcoming" },
];

const CalendarToolbar = ({ activeView, onViewChange }) => (
  <div className="calendar-toolbar" role="tablist" aria-label="Calendar views">
    {VIEWS.map((view) => (
      <button
        key={view.id}
        type="button"
        role="tab"
        className={`calendar-toolbar__btn ${
          activeView === view.id ? "is-active" : ""
        }`}
        aria-selected={activeView === view.id}
        onClick={() => onViewChange(view.id)}
      >
        {view.label}
      </button>
    ))}
  </div>
);

export default CalendarToolbar;
